import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';
import { MenuPrintRuleService } from '@packages/charka-common-ui/graphql/types/graphql';

const QUERY = graphql(`
  query GetPrintRuleAssignment($menuId: ID!, $service: MenuPrintRuleService!) {
    getPrintRuleAssignment(menuId: $menuId, service: $service) {
      id
      menuId
      menuPrintRuleId
    }
  }
`);

export function usePrintRuleAssignment(menuId: string, service: MenuPrintRuleService) {
  return useQuery(QUERY, {
    variables: {
      menuId,
      service,
    },
  });
}
